import { IRootState, ISearchType } from '@/store/types/IRootState';

const rootStateMutations = {
  setError(state: IRootState, params: {status: number, message: string}) {
    state.error.status =  params.status;
    state.error.message = params.message;
  },
  setLoading(state: IRootState, newValue: boolean) {
    state.isLoading = newValue;
  } ,
  setSelectedSearchFieldOption(state: IRootState, newOption: string) {
    const option = state.searchTypes.filter(type => type.id === newOption)[0];
    state.selectedSearchFieldOption = option;
  },
  setItemsCounter(state: IRootState, newCount: number) {
    state.itemsCounter = newCount;
  },
  clearItemsCounter(state: IRootState) {
    state.itemsCounter = 0;
  },
  updateMaxItems(state: IRootState) {
    state.currentMaxItems += state.defaultMaxItems;
  },
  resetMaxItems(state: IRootState) {
    state.currentMaxItems = state.defaultMaxItems;
  },
  setSearchString(state: IRootState, newSearchString: string) {
    state.searchString = newSearchString;
  },
  setHasFiltersFlag(state: IRootState, newHasFilterFlag: boolean) {
    state.hasFilters = newHasFilterFlag;
  },
  setDisplayList(state: IRootState, isGrid: boolean) {
    state.isDisplayList = isGrid;
  },
};

export default rootStateMutations;
